import * as React from 'react';
import * as acl from 'common/utils/acl';

import { AppState } from 'common/models/AppState';
import { Datetime } from 'common/components/Datetime';
import { EntityActions } from 'common/entity';
import { InfiniteList } from 'common/components/InfiniteList';
import { Loading } from 'common/components/Loading';
import { RowActionButton } from '../../common/components/RowActionButton';
import { Table } from 'reactstrap';
import { Tag } from 'common/api/models/Tag';
import { TagApi } from '../../common/api/resources/TagApi';
import { User } from 'common/api/models/User';
import { toApiError } from 'common/utils/api';
import { stripQueryTerms, getQueryTerm } from 'common/utils/search';

interface TagsTableProps {
  appState: AppState;
  entityActions: EntityActions;
  query: string;
  onEdit: (user: User) => void;
}
interface TagsTableState {
  tags: Tag[];
  next?: string;
  isLoading: boolean;
  error?: string;
}
export class TagsTable extends React.Component<TagsTableProps, TagsTableState> {
  state: TagsTableState = { tags: [], isLoading: true };

  handleLoadMore = () => {
    this.reload(this.props.query, this.state.next);
  };

  componentDidMount() {
    this.reload(this.props.query);
  }

  componentDidUpdate(prevProps: TagsTableProps) {
    if (prevProps.query !== this.props.query) {
      this.reload(this.props.query);
    }

    if (prevProps.appState !== this.props.appState) {
      this.reload(this.props.query);
    }
  }

  reload(search: string, from?: string) {
    this.setState({ isLoading: true });

    const q = stripQueryTerms(search, ['type']);
    const type = getQueryTerm(search, 'type');

    TagApi.findTags({ q, type, from: from }).then(
      results => {
        this.setState(prevState => ({
          ...prevState,
          tags: from ? prevState.tags.concat(results.data!) : results.data!,
          next: results.next,
          error: undefined,
          isLoading: false,
        }));
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  }

  render() {
    const cols = 4;

    return (
      <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.handleLoadMore}>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}

        <Table className="table-clickable" responsive={true} hover={true} striped={true}>
          <thead>
            <tr>
              <th>Name</th>

              <th>Type</th>
              <th>Created</th>
              <th>Updated</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {!this.state.isLoading &&
              !this.state.error &&
              this.state.tags.length === 0 && (
                <tr>
                  <td colSpan={cols}>No results found.</td>
                </tr>
              )}
            {this.state.tags.map(t => (
              <tr key={t.id} data-id={t.id}>
                <td>{t.name}</td>

                <td>{t.type}</td>
                <td>
                  <Datetime at={t.createAt} />
                </td>
                <td>
                  <Datetime at={t.updateAt} />
                </td>
                <td>
                  {acl.isManager(this.props.appState.user!) && (
                    <RowActionButton item={t} icon="pencil" onClick={this.props.onEdit} />
                  )}
                </td>
              </tr>
            ))}
            {this.state.isLoading && (
              <tr>
                <td colSpan={cols}>
                  <Loading />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </InfiniteList>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Tags/TagsTable.tsx